'use client';
import React, { useRef, useEffect, useState } from 'react';

const faqs = [
  {
    question: 'Healing कितने समय में असर करती है? (How long does healing take to show results?)',
    answer: 'Healing का असर हर व्यक्ति के लिए अलग होता है। कुछ लोगों को पहले session में ही गहरा बदलाव महसूस होता है, जबकि कुछ को 3-5 sessions लग सकते हैं। यह आपकी healing journey की गहराई, आपके issues की complexity, और आपकी receptivity पर निर्भर करता है। Most clients report significant shifts within 1-3 sessions.',
  },
  {
    question: 'क्या Online Session संभव है? (Are online sessions possible?)',
    answer: 'हाँ, बिल्कुल! Online sessions equally effective हैं। Healing energy distance को transcend करती है। Sessions Zoom या Google Meet के through conduct होते हैं। आपको बस एक quiet, comfortable space और stable internet connection चाहिए। हम India और worldwide clients के साथ काम करते हैं।',
  },
  {
    question: 'क्या यह Medical Treatment का विकल्प है? (Is this an alternative to medical treatment?)',
    answer: 'नहीं। Healing sessions medical treatment का replacement नहीं हैं। ये complementary therapy हैं जो आपके medical treatment के साथ-साथ काम करती हैं। हम always recommend करते हैं कि आप अपने doctor से consult करते रहें। Healing sessions emotional, energetic, और spiritual levels पर काम करते हैं।',
  },
  {
    question: 'कितने Sessions लेने चाहिए? (How many sessions should I take?)',
    answer: 'यह आपकी individual needs और goals पर depend करता है। कुछ issues के लिए 1-2 sessions काफी होते हैं, जबकि deep-rooted patterns के लिए ongoing sessions beneficial होते हैं। हम पहले एक free discovery call में आपकी situation assess करके एक personalized healing plan बनाते हैं।',
  },
  {
    question: 'Payment कैसे करें? (How to make payment?)',
    answer: 'हम multiple payment options accept करते हैं: UPI (GPay, PhonePe, Paytm), Razorpay, Debit/Credit Cards, और Net Banking। Booking confirmation के बाद payment link provide किया जाता है। Monthly webinar के लिए ₹199 का payment registration confirm करता है।',
  },
  {
    question: 'क्या Sessions Confidential हैं? (Are sessions confidential?)',
    answer: 'बिल्कुल। सभी sessions पूरी तरह confidential हैं। आपकी personal information, session details, और healing journey strictly private रखी जाती है। Shruti highest ethical standards of confidentiality maintain करती हैं। आपकी healing journey sacred है।',
  },
  {
    question: 'Session के बाद क्या expect करें? (What to expect after a session?)',
    answer: 'Session के बाद आप deep relaxation, emotional release, increased clarity, vivid dreams, या lightness feel कर सकते हैं। कुछ लोगों को temporary fatigue भी हो सकती है जो healing process का हिस्सा है। Integration support provide किया जाता है। खूब पानी पिएं और rest करें।',
  },
  {
    question: 'Booking और Cancellation Policy क्या है?',
    answer: 'Sessions website, WhatsApp, या booking link के through book किए जा सकते हैं। Cancellation कम से कम 24 hours पहले करनी होगी reschedule के लिए। Monthly program fees non-refundable हैं once the healing program has begun. Emergency situations में please WhatsApp करें।',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      id="faq"
      className="relative py-24 overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #130a24 0%, #0d0818 100%)' }}
    >
      <div className="absolute inset-0 lotus-bg opacity-30 pointer-events-none" />

      <div className="max-w-4xl mx-auto px-6 relative z-10">
        <div
          ref={ref}
          className={`transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {/* Header */}
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-4 mb-4">
              <div className="h-px w-12 bg-gradient-to-r from-transparent to-[#c9a84c]/60" />
              <span className="text-[#c9a84c] text-xs tracking-[0.4em] uppercase font-medium">Questions & Answers</span>
              <div className="h-px w-12 bg-gradient-to-l from-transparent to-[#c9a84c]/60" />
            </div>
            <h2
              className="font-serif text-4xl md:text-5xl font-bold mb-4"
              style={{
                background: 'linear-gradient(135deg, #c4b5fd 0%, #9b7fe8 50%, #c9a84c 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              Frequently Asked Questions
            </h2>
            <div className="section-divider" />
          </div>

          {/* FAQ Items */}
          <div className="space-y-3">
            {faqs?.map((faq, index) => (
              <div
                key={index}
                className={`faq-item overflow-hidden ${openIndex === index ? 'open' : ''}`}
              >
                <button
                  className="w-full flex items-center justify-between p-5 text-left"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span
                    className="font-serif text-base font-medium pr-4"
                    style={{ color: openIndex === index ? '#c9a84c' : '#e8dff5' }}
                  >
                    {faq?.question}
                  </span>
                  <span
                    className="text-[#c9a84c] text-xl flex-shrink-0 transition-transform duration-300"
                    style={{ transform: openIndex === index ? 'rotate(45deg)' : 'rotate(0deg)' }}
                  >
                    +
                  </span>
                </button>
                <div
                  className="overflow-hidden transition-all duration-300"
                  style={{ maxHeight: openIndex === index ? '400px' : '0' }}
                >
                  <p className="px-5 pb-5 text-[#c4b5fd]/70 text-sm leading-relaxed">
                    {faq?.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
